import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { validateAmount as validateAmountUtil } from 'src/app/shared/utils/payments';

type Result = Record<string, string> | EmptyObject;

export function useValidateAmount(): () => Result {
	const { translate, localizeCurrency } = useI18n();
	const {
		data: {
			promotionCountrySettings: { maximumAmount, minimumAmount },
			currency,
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();

	return function validateAmount(): Result {
		const amountValidationI18nKey = validateAmountUtil({ amount, maximumAmount, minimumAmount });
		if (!amountValidationI18nKey) return {};

		const amountError = translate(amountValidationI18nKey, {
			...(minimumAmount && {
				minimumAmount: localizeCurrency(minimumAmount, currency.code, {
					currencyDisplay: 'narrowSymbol',
					amountInBaseUnits: false,
				}),
			}),
			...(maximumAmount && {
				maximumAmount: localizeCurrency(maximumAmount, currency.code, {
					currencyDisplay: 'narrowSymbol',
					amountInBaseUnits: false,
				}),
			}),
		});
		return {
			amount: amountError,
			...(amount === 0 ? { amountSelection: amountError } : { customAmount: amountError }),
		};
	};
}
